export default __webpack_public_path__ + "static/media/Heinrich-Boell-Stiftung-Logo.44f77faf.jpg";